var $grid;
var $filter;
var counter;
var filterYear = "";
var filterLink = "";
var filterType = "";
var firstLoad = true;

var goto = false;

var filterOr = []

$(document).ready(function() {
    Isotope.Item.prototype._create = function () {
        // assign id, used for original-order sorting
        this.id = this.layout.itemGUID++;
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.sortData = {};
    };

    Isotope.Item.prototype.layoutPosition = function () {
        this.emitEvent('layout', [this]);
    };

// layout mode that does not position items
    Isotope.LayoutMode.create('none');
});

// Reset Filter LocalStorage
function resetFilterStorage(){
	localStorage.setItem('filterValue', '');
}

// Filter functionality
function resetFilter() {
	filterYear = "";
	filterLink = "";
	$('input[data-filter]').prop('checked', false);
	filterType = "";

	resetFilterStorage();


	filter();

	$('.filter-tab-content').hide();
	$('a[data-filter]').removeClass('active');
}

function setFilterYear(item) {
	filterYear = "." + item.val();
}

function setFilterLink(item) {
	filterLink = "." + item.attr('data-filter');
}

function addFilterType(item) {
	if (item.is(':checked')) {
		filterOr.push("." + item.attr('data-filter'));
	} else {
		filterOr.splice(filterOr.indexOf("." + item.attr('data-filter')),1);
    }

	//filterType = filterOr.join('');
	filterType = filterOr;
	return;
}

function getPreSelected() {
	$.each($('.filter-year'), function(index, item) {
		setFilterYear($(item));
	});
	
	$.each($('a[data-filter].active'), function(index, item) {
		setFilterLink($(item));
	});

	$.each($('input[data-filter][checked]'), function(index, item) {
		addFilterType($(item));
	});
	
	filter();
}



function setSotredFilters() {
	if (localStorage.getItem('filterValue') !== 'undefined' && localStorage.getItem('filterValue') !== '' && localStorage.getItem('filterValue') !== null){
		var selected = localStorage.getItem('filterValue').split(',');
		$.each(selected, function (index, value) {
			var field = value.split('.');
			$('#filter-'+field[2]).attr('checked', true);
		});
	}
}
setSotredFilters();

function filter($goto = null) {
	var filterValue = "";

	if (filterType.length > 0) {
		$.each(filterType, function(index, item) {
			filterValue += filterYear + filterLink + item;

			if (index < filterType.length-1) {
				filterValue += ",";
			}

		});
	} else {
		filterValue = filterYear + filterLink;
	}

	// ptool fallback
    if (!firstLoad && $('.filter-date.filter-ptool .filter-month').length) {
        $goto = $('.filter-date.filter-ptool .filter-month').first();
    }

	if ($goto) {
        $grid.on( 'layoutComplete', ( event, laidOutItems ) => {
            $('html, body').animate({
                scrollTop: $goto.offset().top
            }, 500);
		})
	}

	$grid.isotope({
		filter: filterValue
	});


	if (!firstLoad && !$goto) {
	    $('html, body').animate({
	        scrollTop: $grid.offset().top  - $('.filter-nav').height() - 80
	    }, 200);
	}

    firstLoad = false;
	$(window).trigger('filtered');
	if (!$('.filter-date').length) {
        localStorage.setItem('filterValue', filterValue);
	}
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

$(window).on('load', function() {
	counter = $('.filter-counter');

	$grid = $('.filter-list').first();

	if ($grid && $grid.length) {
		/* init isotope */

        Isotope.Item.prototype._create = function() {
            // assign id, used for original-order sorting
            this.id = this.layout.itemGUID++;
            // transition objects
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            };
            this.sortData = {};
        };

        Isotope.Item.prototype.layoutPosition = function() {
            this.emitEvent( 'layout', [ this ] );
        };

        Isotope.prototype.arrange = function( opts ) {
            // set any options pass
            this.option( opts );
            this._getIsInstant();
            // just filter
            this.filteredItems = this._filter( this.items );
            // flag for initalized
            this._isLayoutInited = true;
        };

        // layout mode that does not position items
        Isotope.LayoutMode.create('none');

        $grid.isotope({
			// options
			itemSelector: '.filter-item',
			layoutMode: 'none',
			transitionDuration: '0.3s'
		});

		/* wait with layouting until images are loaded */
		$grid.imagesLoaded().progress( function() {
			$grid.isotope('layout');
		});

		/* after layouting */
		$grid.on( 'arrangeComplete layoutComplete', function( event, filteredItems ) {
			if (counter.length) {
				counter.find('span').html(filteredItems.length);
			}
		});

		/*Set Saved Filter Category*/
		if (localStorage.getItem('filterValue') !== 'undefined' && localStorage.getItem('filterValue') !== '' && localStorage.getItem('filterValue') !== null){

			var selected = localStorage.getItem('filterValue').split(',');

			$.each(selected, function (index, value) {

				var field = value.split('.');

				if (typeof field[1] !== 'undefined' && field[1] !== '' && field[1] !== null){
					var $cat = field[1];
					$('a[data-filter="'+field[1]+'"]').addClass('active');
					$('.filter-tab-content.'+$cat+'-category').css({'display':'block',});
				}

				if (typeof field[2] !== 'undefined' && field[2] !== '' && field[2] !== null){


					var id = field[2].replace('f','');
					var $input = $('#filter-'+id);

					$input.prop('checked', true);

					addFilterType($input);
				}
			});
		}

		/* general filter */
		$('a[data-filter]').on('click', function(event) {
            if (!$(this).hasClass('direct')) {
                event.preventDefault();

                if ($(this).parent().hasClass('tab')) {
                    if (!$(this).hasClass('active')) {
                        filterType = "";
                        $('input[data-filter]').prop('checked', false);
                    }
                }

                setFilterLink($(this));

                $('a[data-filter]').removeClass('active');
                $(this).addClass('active');

                filter();
            }
		});


		/* special filter year */
		$('.filter-year').on('change', function(event) {
			setFilterYear($(this));
			filter();
		});

		/* special filter type with input */
		$('input[data-filter]').on('change', function(event) {
			event.preventDefault();
			addFilterType($(this));
			filter();
		});

		/* reset filter */
		$('.filter-reset').on('click', function(event) {
			event.preventDefault();
			resetFilter();
		});

		goto = getUrlParameter('goto');

        if (goto) {
			var $goto = $("#ptool-filter-item-id-"+goto);
			var date;
			if ($goto.length) {
				date = $goto.data('date');

                $('a[data-filter]').removeClass('active');
                $('a[data-filter=date-'+date+']').addClass('active');

                addFilterType($('a[data-filter=date-'+date+']'));
                filter($goto);

			} else {
				console.log("Selected element not found");
			}
        }
	}

	$grid.on('arrangeComplete', function( event, laidOutItems ) {
		$grid.addClass('filter-inited');
		$grid.closest('.row').find('.filter-date').addClass('filter-inited');
		$('.filter-progress').hide();
	});
});

$(window).on('load', function() {
	if ($grid && $grid.length) {
		getPreSelected();
	}
});

/*Reset Stored Filter Values*/
$('nav.main a').click(resetFilterStorage);


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/filter/filter.js
 **/